/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistant extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
    });
  }

  playground({ assistantId, messageContent, messageHistory }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
    });
  }

  availableModels({ assistantId }) {
    return axios.get(`${this.url}/${assistantId}/available_models`);
  }

  generateImage({ assistantId, prompt, image }) {
    const formData = new FormData();
    formData.append('prompt', prompt);
    if (image) {
      formData.append('image', image);
    }
    return axios.post(`${this.url}/${assistantId}/generate_image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new CaptainAssistant();
